import { useState } from 'react';
import type { GameView } from '@secretnenshi/shared';
import { useTheme } from '../theme/useTheme';

/** Spec §74: the public record, newest round first. */
export function Record({ view }: { view: GameView }) {
  const [open, setOpen] = useState(false);
  const c = useTheme();
  const log = view.game!.log;
  const rounds = new Map<number, string[]>();
  for (const e of log) {
    const text = c.describeLog(view, e);
    if (!text) continue;
    rounds.set(e.turn, [...(rounds.get(e.turn) ?? []), text]);
  }
  const ordered = [...rounds.entries()].sort((a, b) => b[0] - a[0]);

  return (
    <section className="section record">
      <button type="button" className="record-toggle" aria-expanded={open} onClick={() => setOpen(!open)}>
        <span className="section-label">Public record</span>
        <span aria-hidden="true">{open ? '−' : '+'}</span>
      </button>
      {open ? (
        <div className="record-body">
          {ordered.map(([turn, lines]) => (
            <div key={turn} className="record-round">
              <h3>Round {turn}</h3>
              {lines.map((l, i) => (
                <p key={i}>{l}</p>
              ))}
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
